export default __webpack_public_path__ + "static/media/04.e61f7404.png";